
        Component.define('page-home', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $slider = $el.find('.wrapper-item-boxes');
const $form           = $('.form');

$el.find('.btn-lembrete').on('click', function(){
    console.log('tete')
    $([document.documentElement, document.body]).animate({
        scrollTop: $el.find('.register').offset().top
    }, 500);
});

$el.ready(function(){
    $('.phone').mask('(00) 00000-0000');
});

$form.validate({
    ignore: ":hidden:not(.hiddenRecaptcha)",
    errorPlacement: function (error, element) {
        if(element.closest(".box-recaptcha").length){
            error.appendTo(element.closest(".box-recaptcha"));
        } else {
            error.insertAfter(element);
        }
    },
    rules: {
        name: {
            required: true,
        },
        email: {
            required: true,
            email: true,
        },
        celphone: {
            required: true,
            minlength: 14,
        },
        veiculo: {
            required: true,
        },
        terms: {
            required: true,
        },
        hiddenRecaptcha: {
            required: function () {
                if (grecaptcha.getResponse() == '') {
                    $el.find('.hiddenRecaptcha').removeClass('error');
                    return true;
                } else {
                    $el.find('.hiddenRecaptcha').removeClass('error');
                    return false;
                }
            }
        }
    },
    messages: {
        name: {
            required: 'Digite o nome!',
        },
        celphone: {
            required: 'Digite o número de celular!',
            minlength: 'Mínimo de 11 dígitos!',
        },
        email: {
            required: 'Digite o e-mail!',
            email: 'E-mail inválido!',
        },
        veiculo: {
            required: 'Digite o veículo de mídia!',
        },
        terms: {
            required: 'Campo obrigatório!'
        },
        'hiddenRecaptcha': {required:  'Campo obrigatório!' }
    },
    submitHandler: function (form) {
        loading.show();
        var $form = $(form);
        var formData = $form.serialize();

        if ($form.hasClass('sending')) {
            return false;
        }

        $form.addClass('sending');

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: formData
        }).done(function (data) {
            if (data.status) {
                $form[0].reset();
                grecaptcha.reset();
                $el.find('.msg-success').fadeIn();
            } else {
                alert("Falha no cadastro.");
            }
        }).fail(function () {
            alert("Falha no cadastro.");
        }).always(function () {
            $form.removeClass('sending');
            loading.hide();
        });

        return false;
    }
});

let createSlider = false;

$window.on('resize', function(){
    if (wW <= 980) {
        if (!createSlider) {
            $slider.slick({
                arrows: false,
                variableWidth: true
            });

            createSlider = true;
        }
    } else {
        if (createSlider) {
            $slider.slick('unslick');

            createSlider = false;
        }
    }
});

window.callbackRecaptcha = function(){
    $('.box-recaptcha').find('label.error').hide();
    $('.box-recaptcha').find('.hiddenRecaptcha').removeClass('error');
}

        });